<div class="d-flex align-items-center">
  <input class="form-check-input mt-0 me-3"
         [class.break-lines]="breakLines"
         type="checkbox"
         [formControl]="field"
         [disabled]="disabled"
         [attr.id]="resolvedInputId"
  >
  <label [for]="resolvedInputId">{{ checkBoxLabel | translate: translateParameters }}</label>
</div>

<div *ngIf="hasHint" class="form-text">{{ hint | translate }}</div>
<div *ngIf="showError" class="form-text text-danger">{{ error | translate }}</div>
